// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"709":"15dd8ead","944":"36ba5193"}[chunkId] + ".chunk.js";
};